import React, { ChangeEvent, useEffect, useState } from "react";
import IErrorDTO from "../../../models/DTO/IErrorDTO";
import IGetLotsDTO from "../../../models/DTO/IGetLotsDTO";
import IOnGetLotsDTO from "../../../models/DTO/IOnGetLotsDTO";
import IOnPickListProcessLotDTO from "../../../models/DTO/IOnPickListProcessLotDTO";
import IPickListProcessLotDTO from "../../../models/DTO/IPickListProcessLotDTO";
import EndpointsEnum from "../../../models/EndpointsEnum";
import ICatalog_Item from "../../../models/ICatalog_Item";
import ILot from "../../../models/ILot";
import ILotUI from "../../../models/ILotUI";
import INewPick_List_Item_Lot_Map from "../../../models/INewPick_List_Item_Lot_Map";
import INotification from "../../../models/INotification";
import IOwTableCols from "../../../models/IOwTableCols";
import IPick_List from "../../../models/IPick_List";
import IPick_List_Catalog_Item_Detail from "../../../models/IPick_List_Catalog_Item_Detail";
import IPick_List_Item_Lot_Map from "../../../models/IPick_List_Item_Lot_Map";
import ISupplierModel from "../../../models/ISupplierModel";
import IUserUI from "../../../models/IUserUI";
import NotificationLevelEnum from "../../../models/NotificationLevelEnum";
import NotificationPositionEnum from "../../../models/NotificationPositionEnum";
import UserService from "../../../services/UserService";
import OwButton from "../OwButton/OwButton";
import OwInputWrapper from "../OwInputWrapper/OwInputWrapper";
import OwLabel from "../OwLabel/OwLabel";
import OwTable from "../OwTable/OwTable";
import Typeahead from "../Typeahead/Typeahead";
import { Socket } from "socket.io-client";

type Props = {
    catalogItem: ICatalog_Item;
    userModel: IUserUI;
    supplierModel: ISupplierModel;
    socket: Socket;
    pickList: IPick_List;
    notifyFn: (data: IErrorDTO | null, _notification?: any, isFormatted?: boolean) => void;
    pickListCatItemDetail: IPick_List_Catalog_Item_Detail;
};

export const CatalogItemLotAssignmentDetailView: React.FC<Props> = (props) => {
    const renderLotDetail = (mapItem: IPick_List_Item_Lot_Map) => {
        return (
            <div>
                <div>{mapItem.Lot?.name}</div>
                <div>
                    <OwLabel title={"qty"} postText={":"} />
                    {mapItem.Lot?.qty}
                </div>
            </div>
        );
    };

    const toggleEditMode = () => {
        setEditMode(!editMode);
    };

    const renderActionCol = (mapItem: IPick_List_Item_Lot_Map) => {
        return <div>{editMode ? null : <i className={"pointer fad fa-pencil text-primary"} onClick={toggleEditMode} />}</div>;
    };

    const handleExistingQtyChange = (e: ChangeEvent<any>, mapItem: IPick_List_Item_Lot_Map) => {};

    const renderQtyCol = (mapItem: IPick_List_Item_Lot_Map) => {
        return (
            <div>
                {editMode ? (
                    <OwInputWrapper
                        name={"qty"}
                        fn={(e: ChangeEvent<any>) => {
                            handleExistingQtyChange(e, mapItem);
                        }}
                    />
                ) : (
                    mapItem.qty
                )}
            </div>
        );
    };

    const initCols: IOwTableCols[] = [
        {
            title: "",
            valueProp: "",
            renderFnEmitsRow: true,
            renderFn: renderActionCol,
        },
        {
            title: "qty",
            valueProp: "",
            renderFn: renderQtyCol,
            renderFnEmitsRow: true,
        },
        {
            title: "lot",
            valueProp: "",
            renderFn: renderLotDetail,
            renderFnEmitsRow: true,
        },
    ];

    const [columns, setColumns] = useState<IOwTableCols[]>(initCols);
    const [dataSet, setDataSet] = useState<IPick_List_Item_Lot_Map[]>(
        props.pickListCatItemDetail.Pick_List_Catalog_Item_Map.Pick_List_Item_Lot_Maps || []
    );
    const [isDataFetching, setIsDataFetching] = useState(false);
    const [isInitialData, setIsInitialData] = useState(false);
    const [lotQty, setLotQty] = useState(1);
    const [foundLots, setFoundLots] = useState<ILotUI[]>([]);
    const [selectedLot, setSelectedLot] = useState<ILot | undefined>();
    const [clearTypeahead, setClearTypeahead] = useState<boolean>(false);
    const [editMode, setEditMode] = useState<boolean>(false);

    useEffect(() => {
        props.socket.on(EndpointsEnum.CatalogItemOnGetLots, onGetLots);
        props.socket.on(EndpointsEnum.PickListOnProcessLot, onProcessLot);

        return () => {
            props.socket.removeListener(EndpointsEnum.CatalogItemOnGetLots, onGetLots);
            props.socket.removeListener(EndpointsEnum.PickListOnProcessLot, onProcessLot);
        };
    }, []);

    const addLot = () => {
        if (selectedLot) {
            const newMap: INewPick_List_Item_Lot_Map = {
                lot_id: selectedLot.id,
                catalog_item_id: props.catalogItem.id,
                pick_list_id: props.pickList.id,
                qty: lotQty,
                pick_list_cat_item_map_id: props.pickListCatItemDetail.Pick_List_Catalog_Item_Map.id,
                order_item_id: props.pickListCatItemDetail.Pick_List_Catalog_Item_Map.order_item_id!,
            };

            const payload: IPickListProcessLotDTO = {
                userGuid: props.userModel.guid,
                userToken: props.userModel.token,
                supplierGuid: props.supplierModel.guid,
                lotMap: newMap,
            };

            props.socket.emit(EndpointsEnum.PickListProcessLot, payload);
        }
    };

    const onProcessLot = (data: IOnPickListProcessLotDTO) => {
        if (data.pickListItemLotMap.catalog_item_id === props.catalogItem.id) {
            const notification: INotification = {
                message: "successfully_processed_lot",
                position: NotificationPositionEnum.bc,
                level: NotificationLevelEnum.success,
            };

            props.notifyFn(null, notification);
        }
    };

    const getLots = (name: string) => {
        const payload: IGetLotsDTO = {
            userGuid: props.userModel.guid,
            userToken: props.userModel.token,
            supplierGuid: props.supplierModel.guid,
            catalogItemGuid: props.catalogItem.guid,
            queryString: `?name=${name}`,
            limit: 8,
            rowGuid: props.catalogItem.guid,
        };

        props.socket.emit(EndpointsEnum.CatalogItemGetLots, payload);
    };

    const onGetLots = (data: IOnGetLotsDTO) => {
        if (data.rowGuid === props.catalogItem.guid) {
            setFoundLots(data.lots);
        }
    };

    const renderFoundLots = (lot: ILot) => {
        return (
            <div>
                <div>{lot.name}</div>
                <div>{lot.qty}</div>
                <div>{lot.exp_date}</div>
            </div>
        );
    };

    // createNewLot = (row: IOrder_ItemUI) => {
    //     const component = (
    //         <CreateLotSidebar
    //             userModel={this.props.userModel}
    //             supplierModel={this.props.supplierModel}
    //             socket={this.props.socket}
    //             cancel={(refresh?: boolean, data?: IOnProcessLotDTO) => {
    //                 this.cancelSidebar(row, data!);
    //             }}
    //             catalogItemModel={row.Catalog_Item!}
    //         />
    //     );
    //
    //     this.props.setSidebarComponent(component);
    //     this.props.toggleSidebar(true);
    //
    //     this.setState({
    //         clearTypeahead: true,
    //     });
    // };
    //
    // cancelSidebar = (row: IOrder_ItemUI, data: IOnProcessLotDTO) => {
    //     console.log("Add Data: ", data);
    //     console.log("For Row: ", row);
    //
    //     this.props.setSidebarComponent(null);
    //     this.props.toggleSidebar(false);
    // };

    const renderLotItems = (lot: ILotUI) => {
        return (
            <div className={"text-center"}>
                <div>{lot.name}</div>
                {lot.exp_date ? (
                    <div className={"text-small d-flex"}>
                        <OwLabel title={"exp"} postText={":"} className={"me-1"} />
                        {UserService.parseDate(lot.exp_date)}
                    </div>
                ) : null}
            </div>
        );
    };
    //
    // addLot = (row: IOrder_ItemUI) => {
    //     let lot = this.state.selectedLots[row.guid];
    //
    //     if (!lot) {
    //         return null;
    //     }
    //
    //     lot.qty = 0;
    //
    //     let orderItems = this.state.orderItems;
    //
    //     let orderItemLotMap = this.state.packingList.Order_Item_Lot_Maps;
    //
    //     for (let orderItem of orderItems) {
    //         if (orderItem.guid === row.guid) {
    //             if (!orderItem.Lots) {
    //                 orderItem.Lots = [];
    //             }
    //
    //             let newLotMap: INewOrder_Item_Lot_Map = {
    //                 lot_id: lot.id,
    //                 order_item_id: orderItem.id,
    //                 order_id: orderItem.order_id!,
    //                 catalog_item_id: orderItem.catalog_item_id,
    //                 packing_list_id: this.state.packingList.id,
    //                 qty: 0,
    //             };
    //
    //             // @ts-expect-error
    //             orderItemLotMap.push(newLotMap);
    //
    //             if (orderItem.Lots.length) {
    //                 let lotExists = false;
    //
    //                 for (let existingLot of orderItem.Lots) {
    //                     if (lot.guid === existingLot.guid) {
    //                         lotExists = true;
    //                     }
    //                 }
    //
    //                 if (!lotExists) {
    //                     orderItem.Lots.push(lot);
    //                 }
    //             } else {
    //                 orderItem.Lots.push(lot);
    //             }
    //             // orderItem.Lot = lot;
    //             // orderItem.Packing_List_Order_Item_Map.
    //         }
    //     }
    //
    //     let packingList = this.state.packingList;
    //
    //     packingList.Order_Item_Lot_Maps = orderItemLotMap;
    //
    //     this.setState({ orderItems, packingList });
    // };
    //
    // deleteLot = (lot: ILotUI, parentRowIndex: number) => {
    //     let orderItems = this.state.orderItems;
    //
    //     let orderItem = orderItems[parentRowIndex];
    //
    //     if (orderItem && orderItem.Lots) {
    //         for (let itemLot of orderItem.Lots) {
    //             if (itemLot.guid === lot.guid) {
    //                 itemLot.deleteFlag = true;
    //             }
    //         }
    //     }
    //
    //     this.setState({
    //         orderItems,
    //         hasUnsavedChanges: true,
    //     });
    // };

    const selectedLotFn = (lot: ILot) => {
        setSelectedLot(lot);
    };

    const clearTypeaheadFn = () => {
        setSelectedLot(undefined);
        setClearTypeahead(false);
        setFoundLots([]);
    };

    const handleLotQty = (e: ChangeEvent<any>) => {
        const value = e.target.value;
        const name = e.target.name;

        setLotQty(Number(value));
    };

    return (
        <div className={"CatalogItemLotAssignmentDetailView"}>
            <div className={"row mb-2 d-print-none"}>
                <div className={"col-3"}>
                    <Typeahead
                        placeholder={"search"}
                        isSelectableFn={() => {
                            return true;
                        }}
                        typeaheadApiFn={getLots}
                        typeaheadItems={foundLots}
                        itemsRenderFn={renderFoundLots}
                        selectedItemFn={selectedLotFn}
                        selectedItem={selectedLot}
                        selectedItemTitleProp={"name"}
                        clearTypeahead={clearTypeahead}
                        clearTypeaheadCallback={clearTypeaheadFn}
                    />
                </div>
                <div className={"col-1"}>
                    <OwInputWrapper name={"lotQty"} fn={handleLotQty} value={lotQty} />
                </div>
                <div className={"col-2"}>
                    <OwButton leftIconClass={"fas fa-plus"} title={"add"} fn={addLot} />
                </div>
            </div>
            <div>
                <OwTable
                    columns={columns}
                    dataSet={dataSet}
                    userModel={props.userModel}
                    supplierModel={props.supplierModel}
                    dataFetch={isDataFetching}
                    initialData={isInitialData}
                />
            </div>
        </div>
    );
};
